/** A row in a composer picker menu. */
export interface IComposerPickerOption {
  value: string;
  label: string;
  /** The grey second line. Omitted renders a single-line row. */
  description?: string;
  /** Options carrying one are grouped under it, after every ungrouped option. */
  group?: string;
}

/** Matching rules shared by every composer picker menu. */
export class ComposerPickerMenuHelper {
  /** The surface every composer pill shares (Figma A-M, Pill 841:9897). */
  static readonly PILL_CLASS_NAMES =
    'flex h-7 items-center gap-sm rounded-full border-1/2 border-border-secondary bg-bg-primary shadow-xs txt-extra-small-medium text-text-primary transition-colors';

  /** Case-insensitive substring over what the row actually shows, so a search either matches the
   * visible text or it does not. */
  static matchesSearch(option: IComposerPickerOption, search: string): boolean {
    return `${option.label} ${option.description ?? ''}`
      .toLowerCase()
      .includes(search.trim().toLowerCase());
  }

  static getSelectedLabel(
    options: readonly IComposerPickerOption[],
    value: string,
    fallbackLabel: string
  ): string {
    return (
      options.find((option) => option.value === value)?.label ?? fallbackLabel
    );
  }

  static groupLabels(options: readonly IComposerPickerOption[]): string[] {
    return Array.from(
      new Set(options.flatMap((option) => (option.group ? [option.group] : [])))
    );
  }
}
